<template>
  <div class="info-box">
    <div class="p-4 flex flex-col overflow-y-auto gap-y-3 border-t flex-1">
      <el-form
        v-if="
          [4, 6].includes(state.meeting.status) &&
          !props.search &&
          state.meeting?.belonger_id == $store.state?.loginUser?.id
        "
        :model="state.model"
        label-width="auto"
        label-position="top"
        ref="formDom"
        size="large"
      >
        <ul class="flex gap-x-5">
          <el-form-item
            label="财务审批"
            prop="cfo"
            :rules="[
              { required: true, message: '请选择财务审批人', trigger: 'blur' },
            ]"
          >
            <c_userselect v-model="state.model.cfo" :type="2" class="!w-60" />
          </el-form-item>
          <el-form-item
            label="总经理审批"
            prop="ceo"
            :rules="[
              {
                required: true,
                message: '请选择总经理审批人',
                trigger: 'blur',
              },
            ]"
          >
            <c_userselect v-model="state.model.ceo" :type="3" class="!w-60" />
          </el-form-item>
        </ul>
        <el-form-item label="说明">
          <el-input v-model="state.model.intro" type="textarea"></el-input>
        </el-form-item>
        <ul class="flex justify-center">
          <el-button type="info">取消</el-button>
          <el-button type="primary" class="!w-32" @click="onSubmit()">
            提交
          </el-button>
        </ul>
      </el-form>
      <ul class="font-bold text-center text-gray-900 text-base mt-5">
        {{
          state.meeting?.bill_title
        }}会议项目核算单
      </ul>
      <c_cell title="会议名称" class="mt-5">
        <template #default>
          <strong>{{ state.meeting?.name }}</strong>
        </template>
      </c_cell>
      <ul class="grid grid-cols-2 mt-3">
        <c_cell title="会议编号" :value="state.meeting?.number" />
        <c_cell
          title="会议时间"
          :value="state.meeting?.start_date + ' ~ ' + state.meeting?.end_date"
        />
      </ul>
      <ul class="flex gap-x-5 mt-3">
        <c_cell title="会议负责人" :value="state.meeting?.belonger_name" />
        <!-- <c_cell title="设计师" :value="state.meeting?.start_time" />
        <c_cell title="车队调度员" :value="state.meeting?.start_time" />
        <c_cell title="物料采购员" :value="state.meeting?.start_time" /> -->
      </ul>
      <div class="border rounded-lg p-2.5">
        <strong>一、会议核算审批摘要信息</strong>
        <div class="flex flex-col gap-y-3 mt-5">
          <ul class="flex gap-x-5">
            <c_cell title="总产值（甲方收款）">
              <template #default>
                <c_money
                  :key="state.meetingAccounting?.receivable_amount"
                  :value="state.meetingAccounting?.receivable_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <c_cell title="已收款">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.collected_amount"
                  :key="state.meetingAccounting?.collected_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <c_cell title="欠款">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.uncollected_amount"
                  :key="state.meetingAccounting?.uncollected_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
          </ul>
          <ul class="flex gap-x-5">
            <c_cell title="报账总金额（乙方）">
              <template #default>
                <c_money
                  :key="state.meetingAccounting?.bill_amount"
                  :value="state.meetingAccounting?.bill_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <c_cell title="报账金额合计">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.bill_item_amount"
                  :key="state.meetingAccounting?.bill_item_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <c_cell title="服务费">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.service_fee_amount"
                  :key="state.meetingAccounting?.service_fee_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <c_cell title="税费">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.tax_fee_amount"
                  :key="state.meetingAccounting?.tax_fee_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <span class="text-gray-400 text-xs" style="margin-left: -20px">
              （报账税率({{
                $formatDecimal(state.meetingAccounting?.tax_fee_rate)
              }}%)）
            </span>
          </ul>
          <ul class="flex gap-x-5 mt-5">
            <c_cell title="采购金额合计">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.purchase_amount"
                  :key="state.meetingAccounting?.purchase_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <!-- <c_cell title="物料采购金额合计">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.material_purchase_amount"
                  :key="state.meetingAccounting?.material_purchase_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <c_cell title="费用采购金额合计">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.expense_purchase_amount"
                  :key="state.meetingAccounting?.expense_purchase_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell> -->
          </ul>
          <ul class="flex gap-x-5">
            <c_cell title="税务成本">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.cost_tax_fee_amount"
                  :key="state.meetingAccounting?.cost_tax_fee_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <span class="text-gray-400 text-xs">
              （（应税报账金额合计 + 服务费）* 成本税率（{{
                $formatDecimal(state.meetingAccounting?.cost_tax_fee_rate)
              }}%)）
            </span>
          </ul>
          <ul class="flex gap-x-5">
            <c_cell title="毛利">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.gross_profit"
                  :key="state.meetingAccounting?.gross_profit"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <span class="text-gray-400 text-xs">
              （报账总金额（乙方）- 采购金额合计 - 税务成本）
            </span>
            <c_cell title="毛利率">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.gross_profit_rate"
                  :key="state.meetingAccounting?.gross_profit_rate"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
          </ul>
          <ul class="flex gap-x-5">
            <c_cell title="设计师应发提成">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.designer_commission"
                  :key="state.meetingAccounting?.designer_commission"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <span class="text-gray-400 text-xs">
              （（参与提成报账金额合计 - 参与提成采购金额合计）*
              设计师提成系数（{{
                $formatDecimal(
                  state.meetingAccounting?.designer_commission_rate,
                )
              }}%））
            </span>
          </ul>
          <ul class="flex gap-x-5">
            <c_cell title="项目经理应发提成">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.manager_commission"
                  :key="state.meetingAccounting?.manager_commission"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <span class="text-gray-400 text-xs">
              （（毛利 - 设计师应发提成）* 项目经理提成系数（{{
                $formatDecimal(
                  state.meetingAccounting?.manager_commission_rate,
                )
              }}%））
            </span>
          </ul>
          <ul class="flex gap-x-5">
            <c_cell title="会议结转收入">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.forward_amount"
                  :key="state.meetingAccounting?.forward_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <span class="text-gray-400 text-xs"> （已收款 - 报账总金额） </span>
          </ul>
        </div>
      </div>
      <strong>二、会议成本及乙方报账金额明细如下：</strong>
      <div>
        <el-table
          :data="state.meetingBillItemList"
          v-loading="!Array.isArray(state.meetingBillItemList)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
        >
          <el-table-column
            label="分类"
            prop="d_cost_type_name"
            :formatter="$tab_TextFormat"
            :width="160"
          />
          <el-table-column
            label="供应商"
            prop="supplier.name"
            :formatter="$tab_TextFormat"
            align="center"
          />
          <el-table-column label="采购摘要" align="center">
            <template #default="{ row }">
              <text>{{ row.specification }}</text>
            </template>
          </el-table-column>
          <el-table-column label="采购单价/数量/天数/总金额" align="right">
            <template #default="{ row }">
              <div class="flex items-center justify-end">
                <text style="color: #080">{{ $priceFormat(row.price) }}</text>
                <text class="text-gray-400">{{ "/" + row.count }}</text>
                <text class="text-gray-400">{{
                  "/" + (row.day_count || "-") + "/"
                }}</text>
                <c_money
                  :value="row.amount"
                  :key="row.amount"
                  :prefix="false"
                  color="#080"
                  bold
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="乙方报账单价/数量/天数/总金额" align="right">
            <template #default="{ row }">
              <div class="flex items-center justify-end">
                <text style="color: #080">{{
                  $priceFormat(row.bill_price)
                }}</text>
                <text class="text-gray-400">{{ "/" + row.bill_count }}</text>
                <text class="text-gray-400">{{
                  "/" + row.bill_day_count + "/"
                }}</text>
                <c_money
                  :value="row.bill_amount"
                  :key="row.bill_amount"
                  :prefix="false"
                  color="#080"
                  bold
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="差额" align="right" :width="120">
            <template #default="{ row }">
              <c_money
                :value="row.diff"
                :key="row.diff"
                :prefix="false"
                class="!w-full justify-end"
                bold
              />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <strong>三、会议收款计划如下：</strong>
      <div>
        <el-table
          :data="state.meetingCollectedPlanList"
          v-loading="!Array.isArray(state.meetingCollectedPlanList)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
        >
          <el-table-column label="收款对象（甲方）" :width="200">
            <template #default="{ row }">
              <text>{{ row.customer?.name }}</text>
              <text class="ml-1 text-xs text-gray-400">
                {{ row.customer?.number }}
              </text>
            </template>
          </el-table-column>
          <el-table-column
            label="计划收款金额"
            prop="amount"
            align="right"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="已收"
            prop="collected_amount"
            align="right"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="欠款"
            prop="uncollected_amount"
            align="right"
            :formatter="$tab_MoneyFormat"
          />
          <el-table-column
            label="附件"
            prop="remark"
            :formatter="$tab_TextFormat"
            :width="500"
            label-class-name="!pl-5"
          >
            <template #default="{ row }">
              <div class="flex flex-wrap gap-x-5 gap-y-2 pl-5">
                <text
                  v-for="file in row.attachment"
                  :key="item"
                  class="hover:underline cursor-pointer text-green-700"
                  @click="$openFile(file.file_url)"
                >
                  {{ file.filename }}
                </text>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="submit-box px-2.5">
      <el-button
        type="danger"
        v-if="[5].includes(state.meeting.status)"
        :icon="Close"
        @click="onQuXiaoHeSuan()"
      >
        取消核算
      </el-button>
      <el-button
        v-if="props.search"
        plain
        :icon="Printer"
        @click="state.showPrint = true"
      >
        打印核算单
      </el-button>
      <!-- <template
        v-if="
          props.search &&
          state.meeting?.belonger_id == $store.state?.loginUser?.id
        "
      >
        <el-button type="danger" :icon="Close" @click="onQuXiaoHeSuan()">
          取消核算
        </el-button>
        <el-button plain :icon="Printer" @click="state.showPrint = true">
          打印核算单
        </el-button>
      </template> -->
    </div>
  </div>
  <el-dialog
    v-model="state.showPrint"
    title="核算单打印"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showPrint = false;
      }
    "
    width="1123px"
    style="height: 95%; max-height: 95%"
    append-to="#home_box"
    modal
  >
    <c_print :id="props.id" @close="state.showPrint = false" />
  </el-dialog>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  meeting_accountingData,
  meeting_accountingSubmit,
  meeting_accountingCancel,
  meeting_accountingDetail,
} from "@/http/meeting";
import { ElMessageBox } from "element-plus";
import { post_response, toDecimal } from "@/utils/funcs";
import c_print from "./HeSuanPrint.vue";

export default {
  components: {
    c_print,
  },
  props: {
    search: Boolean, //是否查看
    id: Number,
  },
  setup(props, { emit }) {
    const printObj = {
      id: "printDom",
      beforeOpenCallback() {},
    };
    const formDom = ref(null);
    const state = reactive({
      model: {
        id: props.id,
      },
      meeting: {},
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      if (props.search) {
        meeting_accountingDetail(props.id).then((res) => {
          if (res.status == 200) {
            const {
              meeting,
              meetingAccounting,
              meetingPurchaseItemList,
              meetingCollectedPlanList,
            } = res.data?.data;
            state.meeting = meeting;
            state.meetingAccounting = meetingAccounting;

            state.meetingBillItemList = meetingPurchaseItemList.map((m) => {
              return {
                ...m,
                diff: toDecimal(m.bill_amount).minus(toDecimal(m.amount)),
              };
            });
            state.meetingCollectedPlanList = meetingCollectedPlanList;
          }
        });
      } else {
        meeting_accountingData(props.id).then((res) => {
          if (res.status == 200) {
            const {
              meeting,
              meetingAccounting,
              meetingCollectedPlanList,
              meetingPurchaseItemList,
            } = res.data?.data;
            state.meeting = meeting;
            state.meetingAccounting = meetingAccounting;
            state.meetingCollectedPlanList = meetingCollectedPlanList;
            state.meetingBillItemList = meetingPurchaseItemList;
          }
        });
      }
    };

    const onClose = () => {
      emit("close");
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          ElMessageBox.confirm(
            `您确定<strong style="color: #080;">提交核算</strong>吗`,
            "提交核算",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              dangerouslyUseHTMLString: true,
              customClass: "c-delete-dialog",
              cancelButtonClass: "is-plain",
            },
          ).then(() => {
            meeting_accountingSubmit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          });
        }
      });
    };

    //取消核算
    const onQuXiaoHeSuan = () => {
      ElMessageBox.prompt(
        `您确定<strong style='color:var(--el-color-danger)'>取消核算</strong>吗？`,
        "提示",
        {
          confirmButtonText: "确定取消",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          confirmButtonClass: "el-button--danger",
          cancelButtonClass: "is-plain",
          inputPattern: /\S/,
          inputType: "textarea",
          inputPlaceholder: "请输入取消说明",
          inputErrorMessage: "请输入取消说明",
        },
      ).then(({ value }) => {
        meeting_accountingCancel({
          id: props.id,
          cancel_msg: value,
        }).then((res) => {
          post_response(res, () => {
            setTimeout(() => {
              emit("close", true);
            }, 500);
          });
        });
      });
    };

    return {
      state,
      props,
      formDom,
      onClose,
      onSubmit,
      printObj,
      onQuXiaoHeSuan,
    };
  },
};
</script>

<style lang="less" scoped></style>
